import React from 'react'
import Filtro from '../comum/Filtro'
import FiltrosAdicionadosItinerarios from './FiltrosAdicionadosItinerarios'
import FiltroItinerariosParaTransferencia from './FiltroItinerariosParaTransferencia'
import PainelFiltragem from '../comum/PainelFiltragem'

export const PainelFiltroItinerarioParaTransferencia = () => (
  <Filtro PainelFiltro={FiltroItinerariosParaTransferencia}/>
);

const PainelFiltrosItinerarioParaTransferencia = () => (
  <PainelFiltragem
    Filtro={PainelFiltroItinerarioParaTransferencia}
    FiltrosAdicionados={FiltrosAdicionadosItinerarios}/>
)

export default PainelFiltrosItinerarioParaTransferencia
